import { LitElement, css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'

export type PipelineIcon = 'cancelled' | 'completed' | 'failed' | 'in_progress' | 'neutral' | 'pending'

import CANCELLED_SVG from './cancelled.svg'
import COMPLETED_SVG from './completed.svg'
import FAILED_SVG from './failed.svg'
import IN_PROGRESS_SVG from './in_progress.svg'
import NEUTRAL_SVG from './neutral.svg'
import PENDING_SVG from './pending.svg'

const Icons: Record<PipelineIcon, string> = {
  'cancelled': CANCELLED_SVG,
  'completed': COMPLETED_SVG,
  'failed': FAILED_SVG,
  'in_progress': IN_PROGRESS_SVG,
  'neutral': NEUTRAL_SVG,
  'pending': PENDING_SVG,
}

@customElement('ep-pipeline-icon')
export class EPPipelineIcon extends LitElement {

  @property({ type: String, attribute: 'name', reflect: true })
  name?: PipelineIcon;

  render() {
    return html`
      <img src=${Icons[this.name ?? 'neutral']} />
    `
  }

  static styles = css`
    :host {
      --size: 16px;
      display: inline-block;
      width: var(--size);
      height: var(--size);
      /* background-color: blue; */
    }

    svg, img {
      display: block;
      width: var(--size);
      height: var(--size);
      margin: 0;
      padding: 0;
      /* background-color: red; */
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-pipeline-icon': EPPipelineIcon
  }
}
